<template>
  <div class="row">
    <div class="col-12 col-lg-4 g c">
        <div class="card card-body">
            <div class="list-group">
                <button type="button" @click="current = {_id: 2, visible: true, websites: [], add: true}" class="list-group-item text-primary text-center list-group-item-action">
                    <i class="fa fa-plus"></i>
                    إضافة إعلان
                </button>
                <button v-for="ad in list" @click="current = ad" :key="ad._id" type="button" :class="`list-group-item list-group-item-action ` + (current._id == ad._id ? 'active' : '')">
                    <i class="fa fa-eye text-success" v-if="ad.visible"></i>
                    <i class="fa fa-eye-slash text-danger" v-if="!ad.visible"></i>
                    <span class="text-success" v-if="ad.websites.includes('madrasati')"> مدرستي</span>
                    <span class="text-info" v-if="ad.websites.includes('noor')"> نور</span>
                    {{ ad.title }}
                </button>
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-8 g c">
        <div class="card card-body" v-if="current._id">
            <div class="form-group">
              <label for="">العنوان</label>
              <input type="text"
                class="form-control" v-model="current.title">
            </div>
            <div class="form-group">
              <label for="">المحتوى HTML</label>
              <textarea class="form-control text-right" v-model="current.value" dir="ltr" rows="5"></textarea>
            </div>
            <br>
              <label for="">إعلان لـ</label>
            <div class="form-check">
                <label class="form-check-label">
                <input type="radio" class="form-check-input" v-model="current.websites" :value="['madrasati']">
                مدرستي
              </label>
            </div>
            <div class="form-check">
                <label class="form-check-label">
                <input type="radio" class="form-check-input" v-model="current.websites" :value="['noor']">
                نور
              </label>
            </div>
            <hr>
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="current.visible">
                منشور
              </label>
            </div>
            <hr>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="save()">
                    <i class="fa fa-save"></i>
                    حفظ
                </button>
                &nbsp;
                <button class="btn btn-outline-danger" v-if="!current.add" @click="deletecurrent()">
                    <i class="fa fa-trash"></i>
                    حذف
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            school: {},
            current: {},
            list: []
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/admin/ads', {
                jwt: localStorage.getItem("jwt")
            })
            .then(function(response){
                if(response.status == 100){
                    g.list = response.response
                }else{
                    alert("حدث خطأ.")
                }
            })
            .fail(function(){
                alert("حدث خطأ")
            })
        },
        save(){
            var g = this;
            $.post(api + '/admin/ads/' + (g.current.add ? 'create' : 'edit'), {
                jwt: localStorage.getItem("jwt"),
                id: g.current._id,
                title: g.current.title,
                websites: g.current.websites,
                visible: g.current.visible,
                value: g.current.value
            })
            .then(function(response){
                if(response.status == 100){
                    g.gett()
                    if(g.current.add){
                        g.current = {}
                    }
                    alert("تم بنجاح", 100)
                }else{
                    alert("حدث خطأ.")
                }
            })
            .fail(function(){
                alert("حدث خطأ")
            })
        },
        deletecurrent(){
            var g = this;
            if(confirm("متأكد من حذف الاعلان نهائياً؟")){
                $.post(api + '/admin/ads/delete', {
                    jwt: localStorage.getItem("jwt"),
                    id: g.current._id
                })
                .then(function(response){
                    if(response.status == 100){
                        g.gett()
                        g.current = {}
                    }else{
                        alert("حدث خطأ.")
                    }
                })
                .fail(function(){
                    alert("حدث خطأ")
                })
            }
        }
    }
}
</script>

<style>

</style>